export default __webpack_public_path__ + "static/media/react.cfa1cd1c.png";